module.exports = __webpack_public_path__ + "img/2023big23.ef94e627.png";